import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { withRouter } from 'react-router-dom'
import { graphql } from 'react-apollo'
import { withApollo } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import { GC_USER_ID, ALABASTER } from '@/constants'
import * as moment from 'moment'
import {
  Grid,
  Button,
  Typography,
  Paper,
  LinearProgress,
  Modal
} from 'material-ui'
import List, { ListItem, ListItemIcon, ListItemText } from 'material-ui/List'
import TextField from 'material-ui/TextField'
import Select from 'material-ui/Select'
import { InputLabel } from 'material-ui/Input'
import { FormControl } from 'material-ui/Form'

import AlchemyReadingCalendar from '@/components/ChartTypes/AlchemyReadingCalendar'
import AlchemySleepWeekly from '@/components/ChartTypes/AlchemySleepWeekly'
import AlchemySleepWeeklyAvg from '@/components/ChartTypes/AlchemySleepWeeklyAvg'

import { READ_DATASETNAME, READ_DATASETS } from '@/graphql/queries/dataset'
import { CREATE_DATASET, UPDATE_DATASET } from '@/graphql/mutations/dataset'

import IconButton from 'material-ui/IconButton'
import AddIcon from 'material-ui-icons/Add'
import CheckIcon from 'material-ui-icons/Check'
import DateRangeIcon from 'material-ui-icons/DateRange'
import ReplayIcon from 'material-ui-icons/Replay'
import ClearIcon from 'material-ui-icons/Clear'
import AccessTimeIcon from 'material-ui-icons/AccessTime'
import EditIcon from 'material-ui-icons/Edit'
import DeleteIcon from 'material-ui-icons/Delete'
import AlarmOnIcon from 'material-ui-icons/AlarmOn'
import CommentIcon from 'material-ui-icons/Comment'
import SentimentSatisfiedIcon from 'material-ui-icons/SentimentSatisfied'
import ChevronRightIcon from 'material-ui-icons/ChevronRight'
import Brightness3Icon from 'material-ui-icons/Brightness3'
import ShowChartIcon from 'material-ui-icons/ShowChart'
import FilterDramaIcon from 'material-ui-icons/FilterDrama'
import CheckBoxOutlineBlankIcon from 'material-ui-icons/CheckBoxOutlineBlank'
import CheckBoxIcon from 'material-ui-icons/CheckBox'
import BatteryCharging30Icon from 'material-ui-icons/BatteryCharging30'

const styles = theme => ({
  paperGoalBlock: {
    marginLeft: theme.spacing.unit * 4,
    marginRight: theme.spacing.unit * 4,
    marginTop: theme.spacing.unit * 1.5,
    marginBottom: theme.spacing.unit * 5,
    boxShadow: '0px 0px 10px #eeeeee'
  },
  paperCalendarView: {
    margin: theme.spacing.unit * 4,
    padding: theme.spacing.unit * 1,
    boxShadow: '0px 0px 10px #eeeeee',
    color: 'grey'
  },
  gridLeft: {
    alignItems: 'center'
  },
  todayPanelGrid: {
    position: 'relative',
    textAlign: 'center',
    padding: 20
  },
  linearColorPrimary: {
    backgroundColor: 'rgba(0, 0, 0, .05)'
  },
  linearBarColorPrimary: {
    backgroundColor: 'rgba(80, 227, 194, .4)'
  },
  linearBarColorPrimaryComplete: {
    backgroundColor: 'lightgreen'
  },
  linearBarColorPrimaryWhite: {
    backgroundColor: 'white'
  },
  button: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee'
  },
  modalAddToday: {
    display: 'inline-block',
    overflow: 'scroll'
  },
  paperAddToday: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  modalContentDone: {
    height: 50,
    width: '100%',
    textAlign: 'left',
    backgroundColor: ALABASTER
  },
  paperNap: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit,
    width: 100,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  paperWidget: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 40,
    borderRadius: theme.spacing.unit * 2
  },
  paperWidgetMood: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    borderRadius: theme.spacing.unit * 2
  },
  paperWidgetComment: {
    textAlign: 'left',
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    padding: theme.spacing.unit,
    margin: theme.spacing.unit,
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  divWidgetMood: {
    textAlign: 'left',
    height: 80,
    borderRadius: theme.spacing.unit * 2
  },
  paperAddTodayMoreInfo: {
    boxShadow: '0px 0px 10px #eeeeee',
    width: '90%',
    marginLeft: '5%',
    marginTop: window.innerHeight * 0.05
  },
  divAddTpday: {
    position: 'relative',
    alignItems: 'center',
    width: '100%'
  },
  iconClear: {
    color: 'rgba(0, 0, 0, .2)',
    fontSize: 26
  },
  iconGetUpTime: {
    color: 'rgba(0, 0, 0, .1)',
    width: 55,
    height: 55
  },
  iconGetUpTimeView: {
    color: 'rgba(0, 0, 0, .1)',
    width: 30,
    height: 30
  },
  iconGetUpTimeView2nd: {
    color: 'rgba(0, 0, 0, .1)',
    width: 24,
    height: 24
  },
  iconSleepScore: {
    color: 'rgba(0, 0, 0, .04)',
    width: 55,
    height: 55
  },
  iconBtnCheck: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    margin: theme.spacing.unit
  },
  iconBtnCheckAdd: {
    backgroundColor: 'white',
    boxShadow: '0px 0px 10px #eeeeee',
    marginBottom: theme.spacing.unit * 2,
    marginRight: theme.spacing.unit
  },
  divClearButton: {
    textAlign: 'right'
  },
  divAddModalButton: {
    textAlign: 'right',
    paddingRight: theme.spacing.unit * 2
  },
  listItemGetUpTime: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  listItemSessionView: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: theme.spacing.unit * 0.8
  },
  listItemSleepTimeComplete: {
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'white',
    paddingLeft: window.innerWidth * 0.1,
    paddingBottom: 20
  },
  listItemGetUpDate: {
    height: 80,
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)',
    paddingLeft: window.innerWidth * 0.18
  },
  listItemBedtimeDate: {
    height: 80,
    width: '100%',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.016)'
  },
  iconSleepAtTimeDate: {
    color: 'rgba(0, 0, 0, .1)',
    width: 20,
    height: 20
  },
  textFieldGetUpTime: {
    width: window.innerWidth * 0.4,
    backgroundColor: 'rgba(80, 227, 194, .1)'
  },
  textFieldGetUpDate: {
    width: window.innerWidth * 0.4
  },
  weightText: {
    textAlign: 'center',
    padding: 0
  },
  textGetUpTime: {
    fontSize: 28,
    color: 'grey'
  },
  textGetUpTimeView: {
    fontSize: 18,
    color: 'grey'
  },
  textGetUpDate: {
    fontSize: 12,
    color: 'lightgrey'
  },
  textFieldMediumLength: {
    width: window.innerWidth * 0.36
  },
  textFieldShortLength: {
    width: window.innerWidth * 0.22
  },
  divBtnAddNew: {
    position: 'relative',
    height: 70,
    textAlign: 'center'
  },
  iconTodayTime: {
    height: 24,
    width: 24
  },
  divTodayPanelTitle: {
    textAlign: 'left',
    marginTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit * 4.5
  },
  btnAddModal: {
    textAlign: 'center'
  }
})

@withApollo
@inject('resultUserSleep')
@inject('resultUserSleepPref')
@observer
@graphql(READ_DATASETS)
@graphql(CREATE_DATASET, { name: 'createDataSet' })
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@graphql(READ_DATASETNAME, {
  name: 'readSleepDefault',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultSleeping',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@graphql(READ_DATASETNAME, {
  name: 'readUserSleepPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserSleepPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
    }
  })
})
@withRouter
@withStyles(styles)
export default class AlchemySleep extends Component {
  constructor(props) {
    super(props)
    this.state = {
      OpenAdd: false,
      OpenView: false,
      timeComplete: moment().format(),
      timeStart: '',
      dateStart: '',
      date: moment().format('l'),
      isCompletedAdd: false,
      isNap: false,
      isCommented: false,
      isSleepTimeDateAdded: false,
      comment: ''
    }
    this.handleSessionDelete = this.handleSessionDelete.bind(this)
  }

  handleClickNap = () => {
    if (this.state.isNap) {
      this.setState({ isNap: false })
      this.props.resultUserSleep.sessionData.nap = '0'
      this.props.resultUserSleep.updateDataBySession()
      this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    } else {
      this.setState({ isNap: true })
      this.props.resultUserSleep.sessionData.nap = '1'
      this.props.resultUserSleep.updateDataBySession()
      this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    }
  }

  saveComment = () => {
    this.props.resultUserSleep.sessionData.comment = this.state.comment
    this.props.resultUserSleep.updateDataBySession()
    this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    this.setState({ isCommented: false })
  }

  saveSleepTimeDate = () => {
    //todo: try delete state for timeStart and dateStart
    this.props.resultUserSleep.sessionData.timeStart = this.state.timeStart
    this.props.resultUserSleep.sessionData.dateStart = this.state.dateStart
    this.props.resultUserSleep.sessionData.hrsDuration = moment
      .duration(
        moment(
          new Date(this.props.resultUserSleep.sessionData.timeComplete)
        ).diff(
          moment(new Date(this.props.resultUserSleep.sessionData.timeStart))
        )
      )
      .asHours()
      .toFixed(2)
    this.props.resultUserSleep.updateDataBySession()
    this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    this.setState({ isSleepTimeDateAdded: false })
  }

  handleOpenAdd = date => {
    this.props.resultUserSleep.sessionByDate = date

    if (moment(new Date(date)).format('l') !== moment().format('l')) {
      this.setState({ date: moment(new Date(date)).format('l') })
      var inputTime = '06:00'
      var str = date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    } else {
      this.setState({
        timeComplete: moment().format()
      })
    }

    this.setState({ OpenAdd: true })
  }

  handleOpenView = date => {
    this.props.resultUserSleep.updatesessionsDataByDate(date)
    this.props.resultUserSleep.sessionByDate = date

    if (moment(new Date(date)).format('l') !== moment().format('l')) {
      this.setState({ date: moment(new Date(date)).format('l') })
      var inputTime = '06:00'
      var str = date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    }

    this.setState({ OpenView: true })
  }

  handleCloseAdd = () => {
    this.setState({
      OpenAdd: false,
      isCompletedAdd: false
    })
  }

  handleCloseView = () => {
    this.setState({
      OpenView: false
    })
  }

  handleChangeAdd = name => event => {
    this.setState({
      [name]: event.target.value
    })

    if (name === 'date') {
      if (!moment(new Date(event.target.value)).isValid()) {
        //todo: delete return
        console.log('invalid date input')
        return
      }
      this.setState({
        date: moment(event.target.value, 'YYYY-MM-DD').format('l')
      })
      var inputTime = moment(new Date(this.state.timeComplete)).format('HH:mm')
      var str = moment(event.target.value + ' ' + inputTime, 'YYYY-MM-DDTHH:mm')
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    } else if (name === 'timeComplete') {
      inputTime = moment(event.target.value, 'HH:mm').format('HH:mm')
      str = this.state.date + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        //todo: delete return
        console.log('invalid date input')
        return
      }
      this.setState({
        timeComplete: moment(new Date(str)).format()
      })
    }
  }

  handleChangeAddMoreInfo = name => event => {
    //timeStart and dateStart to give value based on the default value
    this.setState({
      timeStart: '22:30',
      dateStart: moment(new Date(this.props.resultUserSleep.sessionData.date))
        .subtract(1, 'day')
        .format('l')
    })

    // to add a checkicon like comment

    if (
      moment(new Date(this.props.resultUserSleep.sessionByDate)).format('l') !==
      moment(new Date(this.props.resultUserSleep.sessionData.date)).format('l')
    ) {
      console.log('error: sessionByDate !== sessionData.date')
      return
    }

    if (name === 'dateStart') {
      if (!moment(new Date(event.target.value)).isValid()) {
        console.log('invalid date input')
        return
      }
      this.props.resultUserSleep.sessionData.dateStart = moment(
        event.target.value,
        'YYYY-MM-DD'
      ).format('l')

      var inputTime =
        this.props.resultUserSleep.sessionData.timeStart === ''
          ? '22:30'
          : moment(
              new Date(this.props.resultUserSleep.sessionData.timeStart)
            ).format('HH:mm')
      var str = moment(event.target.value + ' ' + inputTime, 'YYYY-MM-DDTHH:mm')
      this.props.resultUserSleep.sessionData.timeStart = moment(
        new Date(str)
      ).format()
    } else if (name === 'timeStart') {
      inputTime = moment(event.target.value, 'HH:mm').format('HH:mm')
      var sleepDate =
        this.props.resultUserSleep.sessionData.dateStart === ''
          ? moment(new Date(this.props.resultUserSleep.sessionData.date))
              .subtract(1, 'day')
              .format('l')
          : this.props.resultUserSleep.sessionData.dateStart
      str = sleepDate + ' ' + inputTime
      if (!moment(new Date(str)).isValid()) {
        console.log('invalid date input')
      }
      this.props.resultUserSleep.sessionData.timeStart = moment(
        new Date(str)
      ).format()
      this.props.resultUserSleep.sessionData.dateStart = moment(
        new Date(str)
      ).format('l')
    } else {
      this.props.resultUserSleep.sessionData[name] = event.target.value
    }

    //update result data
    this.props.resultUserSleep.updateDataBySession()

    if (name === 'timeStart' || name === 'dateStart') {
      this.setState({
        timeStart: this.props.resultUserSleep.sessionData.timeStart,
        dateStart: this.props.resultUserSleep.sessionData.dateStart,
        isSleepTimeDateAdded: true
      })
    } else if (name === 'comment') {
      this.setState({
        comment: event.target.value,
        isCommented: true
      })
    } else {
      this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    }
  }

  handleCompleteAdd = () => {
    if (!moment(new Date(this.state.timeComplete)).isValid()) {
      console.log('invalid time input')
      return
    }
    if (!moment(new Date(this.state.date)).isValid()) {
      console.log('invalid date input')
      return
    }

    this.updateGetUpTimeToDatabase()
  }

  handleCompleteAddMoreInfo = () => {
    this.props.resultUserSleep.updatesessionsDataAfterAdd()
    this.setState({
      OpenAdd: false,
      OpenView: true,
      isCompletedAdd: false
    })
  }

  handleSessionEdit = id => {
    this.props.resultUserSleep.updateSessionDataById(id)
    this.setState({
      OpenAdd: true,
      isCompletedAdd: true,
      comment: this.props.resultUserSleep.sessionData.comment,
      isNap: this.props.resultUserSleep.sessionData.nap === '0' ? false : true
    })
  }
  handleSessionDelete = id => {
    this.props.resultUserSleep.deleteSessionById(id)
    //update to dataset
    if (this.props.resultUserSleep.data.length === 0) {
      this.updateDataPoints(JSON.stringify([]))
    } else {
      this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    }
    this.setState({ OpenView: false })
  }

  createDataSet = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/login`)
      return
    }
    // if default sleep data is there, refuse to create
    if (this.props.readSleepDefault.allDataSets.length > 0) {
      //('there is already default dataset there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultSleeping',
        description: 'Default sleep tracking data',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        console.log('default sleep data created')
        this.props.resultUserSleep.datasetId = createDataSet.id
      }
    })
  }

  createDataSetUserSleepPref = async dataPoints => {
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      // this.props.history.push(`/login`)
      console.log('not logged in')
      return
    }
    // if default sleep pref data is there, refuse to create
    if (this.props.readUserSleepPreference.allDataSets.length > 0) {
      console.log('there is already default user book preference table there')
      return
    }

    await this.props.createDataSet({
      variables: {
        name: 'defaultUserSleepPreference',
        description: 'defaultUserSleepPreference',
        dataPoints: dataPoints,
        userId: userId
      },
      update: (store, { data: { createDataSet } }) => {
        console.log('default user sleep preference table created')
        this.props.resultUserSleepPref.datasetId = createDataSet.id
      }
    })
  }

  updateGetUpTimeToDatabase = () => {
    const num =
      this.props.resultUserSleep.data.length === 0
        ? 1
        : this.props.resultUserSleep.data[0].id + 1
    const sessionData = {
      id: num,
      timeComplete: this.state.timeComplete,
      date: this.state.date,
      timeStart: '',
      dateStart: '',
      hrsDuration: '',
      type: 'sessionRecord',
      sleepScore: '',
      indicatorColor: 'lightgrey',
      brainClearness: '',
      mood: 0,
      comment: '',
      nap: '0'
    }
    var sleepData = this.props.resultUserSleep.data
    sleepData.splice(0, 0, sessionData)
    this.props.resultUserSleep.updateData(sleepData)
    this.props.resultUserSleep.updateSessionData(sessionData)
    this.updateDataPoints(JSON.stringify(this.props.resultUserSleep.data))
    this.setState({
      isCompletedAdd: true,
      timeComplete: moment().format(),
      date: moment().format('l'),
      timeStart: sessionData.timeStart,
      dateStart: sessionData.dateStart
    })
  }

  updateDataPoints = async dataPoints => {
    if (this.props.readSleepDefault.allDataSets.length === 0) {
      console.log('no default sleep data there')
      return
    }

    try {
      await this.props.UpdateDataSet({
        variables: {
          datasetId: this.props.readSleepDefault.allDataSets[0].id,
          dataPoints: dataPoints
        },
        update: () => {
          console.log('Sleep data updated')
        }
      })
    } catch (e) {
      console.log('There is an error: ' + e)
      if (this.props.readSleepDefault.allDataSets.length === 1) {
        if (this.props.readSleepDefault.allDataSets[0].dataPoints !== '') {
          this.props.resultUserSleep.updateData(
            JSON.parse(this.props.readSleepDefault.allDataSets[0].dataPoints)
          )
        }
      }
      this.signOut()
    }
  }

  signOut = () => {
    global.localStorage.removeItem(GC_USER_ID)
    this.props.history.push(`/login`)
  }

  getPivotArray(dataArray, rowIndex, colIndex, dataIndex) {
    //Code from https://techbrij.com
    var result = {},
      ret = []
    var newCols = []
    for (var i = 0; i < dataArray.length; i++) {
      //specify key (each date) to result
      if (!result[dataArray[i][rowIndex]]) {
        result[dataArray[i][rowIndex]] = {}
      }

      //To get column names - which is none in this case
      if (newCols.indexOf(dataArray[i][colIndex]) === -1) {
        newCols.push(dataArray[i][colIndex])
      }
    }

    // give a value to each key (date)
    // in this case, the value is the unique non-nap wake up time
    for (var key in result) {
      var sessions = []
      //var mini0 = 0
      //var miniX = 0
      //var x = 0
      //var m = 0
      //var miniNew = 0
      for (var j = 0; j < dataArray.length; j++) {
        if (dataArray[j].date === key && dataArray[j].nap === '0') {
          sessions.push(dataArray[j])
          result[dataArray[j][rowIndex]][dataArray[j][colIndex]] = sessions
          if (sessions.length > 1) {
            result[dataArray[j][rowIndex]][2] = 'error'
          } else if (sessions.length === 0) {
            console.log('Error: No wake up time on ' + dataArray[j][rowIndex])
            result[dataArray[j][rowIndex]][2] = ''
          } else if (sessions.length === 1) {
            result[dataArray[j][rowIndex]][2] = sessions[0].timeComplete
          }
        }
      }
    }

    newCols.sort(function(a, b) {
      return new Date(a) - new Date(b)
    })
    var item = []

    //Add content
    for (key in result) {
      item = []
      item.push(key)
      for (i = 0; i < newCols.length; i++) {
        item.push(result[key][newCols[i]] || '')
        item.push(result[key][2])
      }
      ret.push(item)
    }
    return ret
  }

  render() {
    const { classes } = this.props

    // load sleep data from database
    if (this.props.readSleepDefault.loading) {
      return <div>Loading sleep data ... </div>
    }

    if (
      this.props.resultUserSleep.data.length === 0 &&
      !this.props.resultUserSleep.created
    ) {
      if (this.props.readSleepDefault.allDataSets.length === 1) {
        if (this.props.readSleepDefault.allDataSets[0].dataPoints !== '') {
          //('default sleep data is there')
          this.props.resultUserSleep.updateData(
            JSON.parse(this.props.readSleepDefault.allDataSets[0].dataPoints)
          )
        }
      } else if (this.props.readSleepDefault.allDataSets.length === 0) {
        console.log('default sleep data to be added')
        this.createDataSet(JSON.stringify(this.props.resultUserSleep.data))
        this.props.resultUserSleep.updateCreated()
      } else {
        console.log('multiple default tables, please contact support team')
        return (
          <div>
            Error, please contact our support team [readSleepDefault]:{' '}
            {this.props.readSleepDefault.allDataSets.length}
          </div>
        )
      }
    }

    // load user sleep tracking perference from database
    if (this.props.readUserSleepPreference.loading) {
      return <div>Loading user sleep tracking preference data ... </div>
    }

    if (this.props.resultUserSleepPref.data.length === 0) {
      if (this.props.readUserSleepPreference.allDataSets.length === 1) {
        if (
          this.props.readUserSleepPreference.allDataSets[0].dataPoints !== ''
        ) {
          //('default sleep pref data is there')
          this.props.resultUserSleepPref.updateData(
            JSON.parse(
              this.props.readUserSleepPreference.allDataSets[0].dataPoints
            )
          )
          this.props.resultUserSleepPref.updateGoal()
        }
      } else if (this.props.readUserSleepPreference.allDataSets.length === 0) {
        if (!this.props.resultUserSleepPref.created) {
          console.log('create user sleep pref default table')
          this.createDataSetUserSleepPref(
            JSON.stringify(this.props.resultUserSleepPref.data)
          )
          this.props.resultUserSleepPref.updateCreated()
        }
      } else {
        return (
          <div>
            Error, plesae contact our support team [resultUserSleepPref:{' '}
            {this.props.readUserSleepPreference.allDataSets.length}]
          </div>
        )
      }
    }

    var todayWakeUpTime = ''

    if (this.props.resultUserSleep.data.length > 0) {
      var todayWakeUpTimeS = this.props.resultUserSleep.data.filter(
        d =>
          moment(new Date(d.date)).format('l') === moment().format('l') &&
          d.nap === '0'
      )
      if (todayWakeUpTimeS.length === 1) {
        todayWakeUpTime = moment(new Date(todayWakeUpTimeS[0].timeComplete))
      } else if (todayWakeUpTimeS > 1) {
        console.log(
          'error: more than one wake up time today; contact our support team'
        )
        return (
          <div>
            error: more than one wake up time today; contact our support team
          </div>
        )
      }
    }

    var weeklyWakeUpTimeAvg = ''
    var percentGoal = 0
    var minsToGoal = 0

    // aggregate sleep data to daily
    var dataSessionsByDate = this.getPivotArray(
      this.props.resultUserSleep.data,
      'date',
      '',
      ''
    )

    // calc current week average
    var thisWeekSleepData = dataSessionsByDate.filter(
      s =>
        s[2] &&
        moment(new Date(s[0]))
          .endOf('week')
          .format('l') ===
          moment()
            .endOf('week')
            .format('l')
    )
    if (thisWeekSleepData.length > 0) {
      var minsDiff = 0
      var compareTime = moment(new Date(thisWeekSleepData[0][2]))
      thisWeekSleepData.forEach(a => {
        var str =
          moment(new Date(thisWeekSleepData[0][2])).format('l') +
          ' ' +
          moment(new Date(a[2])).format('HH:mm')
        minsDiff += moment(new Date(str)).diff(compareTime, 'minutes')
      })
      var minsDiffAvg = minsDiff / thisWeekSleepData.length
      weeklyWakeUpTimeAvg = compareTime.add(minsDiffAvg, 'minutes')
      var strGoal =
        moment(new Date(thisWeekSleepData[0][2])).format('l') +
        ' ' +
        this.props.resultUserSleepPref.goal.timeCompleteTo
      minsToGoal = -moment(new Date(strGoal)).diff(
        weeklyWakeUpTimeAvg,
        'minutes'
      )
      if (minsToGoal <= 0) {
        percentGoal = 100
      } else {
        var goalmins = moment
          .duration(this.props.resultUserSleepPref.goal.timeCompleteTo)
          .asMinutes()
        percentGoal = 100 * goalmins / (goalmins + minsToGoal)
      }
    }

    return (
      <div>
        <div>
          <div className={classes.divTodayPanelTitle}>
            <Typography
              variant="caption"
              style={{ color: 'lightgrey', fontSize: 15 }}
            >
              Get Up Time
            </Typography>{' '}
          </div>
          {this.props.resultUserSleepPref.goal !== '' ? (
            <Paper className={classes.paperGoalBlock}>
              <Grid container justify="center" spacing={16}>
                <Grid item className={classes.gridLeft}>
                  <div id="todayPanelGrid" className={classes.todayPanelGrid}>
                    <Typography
                      variant="caption"
                      style={{ color: 'lightgrey', fontSize: 15 }}
                    >
                      Today ★
                    </Typography>

                    {todayWakeUpTime !== '' ? (
                      <Typography
                        variant="display1"
                        style={{
                          color: 'lightblue',
                          paddingLeft: 5,
                          paddingTop: 5,
                          paddingBottom: 5
                        }}
                      >
                        {todayWakeUpTime.format('HH:mm')}
                        <IconButton
                          onClick={() =>
                            this.handleSessionEdit(
                              this.props.resultUserSleep.sessionData.id
                            )
                          }
                          className={classes.iconTodayTime}
                        >
                          <EditIcon
                            style={{
                              color: 'rgba(0, 0, 0, 0.15)',
                              fontSize: 15
                            }}
                          />
                        </IconButton>
                      </Typography>
                    ) : (
                      <IconButton
                        className="btn btn-default btn-style"
                        onClick={() => this.handleOpenAdd(moment().format('l'))}
                      >
                        <AddIcon style={{ color: 'lightgrey', fontSize: 36 }} />
                      </IconButton>
                    )}

                    <Typography
                      style={{ color: 'lightgrey', fontSize: 12, padding: 5 }}
                    >
                      {moment().format('l')}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={100}
                      classes={{
                        colorPrimary: classes.linearColorPrimary,
                        barColorPrimary: classes.linearBarColorPrimaryWhite
                      }}
                    />
                  </div>
                </Grid>
                <Grid item className={classes.gridLeft}>
                  <div
                    id="todayPanelGridRight"
                    className={classes.todayPanelGrid}
                  >
                    <Typography
                      variant="caption"
                      style={{ color: 'lightgrey', fontSize: 14 }}
                    >
                      This Week Average ⓘ
                    </Typography>

                    {weeklyWakeUpTimeAvg !== '' ? (
                      <div>
                        <Typography
                          variant="display1"
                          style={{ color: 'lightblue', padding: 5 }}
                        >
                          {weeklyWakeUpTimeAvg.format('HH:mm')}
                        </Typography>
                      </div>
                    ) : (
                      <div>
                        <Typography
                          variant="display1"
                          style={{ color: 'rgba(0, 0, 0, 0.05)', padding: 5 }}
                        >
                          N.A.
                        </Typography>
                      </div>
                    )}
                    {this.props.resultUserSleepPref.goal === '' ? (
                      <div>
                        <Button className={classes.button}>
                          <span style={{ color: 'lightgrey' }}>Add Goal</span>
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Typography
                          style={{ color: 'lightgrey', fontSize: 12 }}
                        >
                          {minsToGoal} mins to Goal{' '}
                          {this.props.resultUserSleepPref.goal.timeCompleteTo}
                        </Typography>
                        <LinearProgress
                          variant="determinate"
                          value={percentGoal}
                          classes={{
                            colorPrimary: classes.linearColorPrimary,
                            barColorPrimary:
                              percentGoal >= 100
                                ? classes.linearBarColorPrimaryComplete
                                : classes.linearBarColorPrimary
                          }}
                        />{' '}
                      </div>
                    )}
                  </div>
                </Grid>
              </Grid>
            </Paper>
          ) : (
            ''
          )}{' '}
        </div>

        <div>
          <Paper className={classes.paperCalendarView}>
            <AlchemySleepWeekly
              data={this.props.resultUserSleep.data}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24 * 0.76
                  : 480 * 1.2
              }
              type={'sleepTracker'}
              goal={this.props.resultUserSleepPref.goal}
              action={(d, t) =>
                t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
              }
            />
          </Paper>
        </div>

        <div>
          <Paper className={classes.paperCalendarView}>
            <AlchemySleepWeeklyAvg
              data={this.props.resultUserSleep.data}
              width={
                window.innerWidth < 630 * 1.2 ? window.innerWidth : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 0.76
                  : 480 * 1.2
              }
              type={'sleepTracker'}
              goal={this.props.resultUserSleepPref.goal}
              action={(d, t) =>
                t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
              }
            />
          </Paper>
        </div>

        <div>
          <Paper className={classes.paperCalendarView}>
            <AlchemyReadingCalendar
              data={dataSessionsByDate}
              width={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24
                  : 630 * 1.2
              }
              height={
                window.innerWidth < 630 * 1.2
                  ? window.innerWidth * 1.24 * 0.76
                  : 480 * 1.2
              }
              type={'sleepTracker'}
              goal={this.props.resultUserSleepPref.goal}
              action={(d, t) =>
                t === 'add' ? this.handleOpenAdd(d) : this.handleOpenView(d)
              }
            />
          </Paper>
        </div>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenView}
          onClose={this.handleCloseView}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          <Paper className={classes.paperAddToday}>
            <div id="GetUpTime" className={classes.divAddTpday}>
              <div className={classes.divClearButton}>
                <IconButton
                  className="btn btn-default btn-style"
                  onClick={this.handleCloseView}
                >
                  <ClearIcon className={classes.iconClear} />
                </IconButton>
              </div>
              <List>
                {this.props.resultUserSleep.sessionsDataByDate.length === 1 ? (
                  <List>
                    <ListItem
                      key={this.props.resultUserSleep.sessionsDataByDate[0].id}
                      className={classes.listItemGetUpTime}
                    >
                      <ListItemIcon>
                        <AlarmOnIcon className={classes.iconGetUpTimeView} />
                      </ListItemIcon>
                      {this.props.resultUserSleep.sessionsDataByDate[0].nap ===
                      '0' ? (
                        <ListItemIcon>
                          <Brightness3Icon
                            className={classes.iconGetUpTimeView2nd}
                          />
                        </ListItemIcon>
                      ) : (
                        <ListItemIcon>
                          <BatteryCharging30Icon
                            className={classes.iconGetUpTimeView2nd}
                          />
                        </ListItemIcon>
                      )}
                      <ListItemText
                        className={classes.weightText}
                        primary={
                          this.props.resultUserSleep.sessionsDataByDate[0]
                            .timeStart === ''
                            ? moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].timeComplete
                                )
                              ).format('HH:mm')
                            : moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].timeStart
                                )
                              ).format('HH:mm') +
                              '~' +
                              moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].timeComplete
                                )
                              ).format('HH:mm')
                        }
                        classes={{
                          primary: classes.textGetUpTimeView,
                          secondary: classes.textGetUpDate
                        }}
                        secondary={
                          this.props.resultUserSleep.sessionsDataByDate[0]
                            .dateStart !== '' &&
                          this.props.resultUserSleep.sessionsDataByDate[0]
                            .dateStart !==
                            this.props.resultUserSleep.sessionsDataByDate[0]
                              .date
                            ? moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].dateStart
                                )
                              ).format('M/D') +
                              ' - ' +
                              moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].date
                                )
                              ).format('M/D')
                            : 'On ' +
                              moment(
                                new Date(
                                  this.props.resultUserSleep.sessionsDataByDate[0].date
                                )
                              ).format('l')
                        }
                      />
                      <IconButton
                        onClick={() =>
                          this.handleSessionEdit(
                            this.props.resultUserSleep.sessionsDataByDate[0].id
                          )
                        }
                        className={classes.iconBtnCheck}
                        size="small"
                      >
                        <EditIcon
                          style={{
                            color: 'lightgrey',
                            fontSize: 20
                          }}
                        />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          this.handleSessionDelete(
                            this.props.resultUserSleep.sessionsDataByDate[0].id
                          )
                        }
                        className={classes.iconBtnCheck}
                        size="small"
                      >
                        <DeleteIcon
                          style={{
                            color: 'lightgrey',
                            fontSize: 20
                          }}
                        />
                      </IconButton>
                    </ListItem>

                    <ListItem
                      key={`sessiodetail-${
                        this.props.resultUserSleep.sessionsDataByDate[0].id
                      }`}
                      className={classes.listItemSessionView}
                    >
                      {this.props.resultUserSleep.sessionsDataByDate[0]
                        .hrsDuration &&
                        this.props.resultUserSleep.sessionsDataByDate[0]
                          .hrsDuration !== '' && (
                          <Paper className={classes.paperWidget}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {
                                this.props.resultUserSleep.sessionsDataByDate[0]
                                  .hrsDuration
                              }
                            </Typography>
                            <Typography
                              style={{ color: 'lightgrey', fontSize: 12 }}
                            >
                              Hours
                            </Typography>
                          </Paper>
                        )}
                      {this.props.resultUserSleep.sessionsDataByDate[0]
                        .sleepScore !== '' && (
                        <Paper className={classes.paperWidget}>
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {
                              this.props.resultUserSleep.sessionsDataByDate[0]
                                .sleepScore
                            }%
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Sleep Quality
                          </Typography>
                        </Paper>
                      )}
                      {this.props.resultUserSleep.sessionsDataByDate[0]
                        .brainClearness !== '' && (
                        <Paper className={classes.paperWidget}>
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {this.props.resultUserSleep.sessionsDataByDate[0]
                              .brainClearness === '10'
                              ? 'Very clear'
                              : this.props.resultUserSleep.sessionsDataByDate[0]
                                  .brainClearness === '20'
                                ? 'Clear'
                                : this.props.resultUserSleep
                                    .sessionsDataByDate[0].brainClearness ===
                                  '30'
                                  ? 'Normal'
                                  : this.props.resultUserSleep
                                      .sessionsDataByDate[0].brainClearness ===
                                    '40'
                                    ? 'Unclear'
                                    : 'Very unclear'}
                          </Typography>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Brain Clearness
                          </Typography>
                        </Paper>
                      )}
                    </ListItem>

                    <ListItem
                      key={`sessioninfo-${
                        this.props.resultUserSleep.sessionsDataByDate[0].id
                      }`}
                      className={classes.listItemSessionView}
                    >
                      {this.props.resultUserSleep.sessionsDataByDate[0].mood !==
                        0 && (
                        <div className={classes.divWidgetMood}>
                          <Paper className={classes.paperWidgetMood}>
                            <Typography
                              style={{ color: 'dimgrey', fontSize: 18 }}
                            >
                              {this.props.resultUserSleep.sessionsDataByDate[0]
                                .mood === '10'
                                ? ':)'
                                : this.props.resultUserSleep
                                    .sessionsDataByDate[0].mood === '20'
                                  ? ':|'
                                  : this.props.resultUserSleep
                                      .sessionsDataByDate[0].mood === '30'
                                    ? ':('
                                    : ''}
                            </Typography>
                          </Paper>
                        </div>
                      )}

                      {this.props.resultUserSleep.sessionsDataByDate[0]
                        .comment !== '' && (
                        <Paper className={classes.paperWidgetComment}>
                          <Typography
                            style={{ color: 'lightgrey', fontSize: 12 }}
                          >
                            Comment
                          </Typography>
                          <Typography
                            style={{ color: 'dimgrey', fontSize: 18 }}
                          >
                            {
                              this.props.resultUserSleep.sessionsDataByDate[0]
                                .comment
                            }
                          </Typography>
                        </Paper>
                      )}
                    </ListItem>
                  </List>
                ) : (
                  this.props.resultUserSleep.sessionsDataByDate.map(s => (
                    <List>
                      <ListItem
                        key={s.id}
                        className={classes.listItemGetUpTime}
                      >
                        <ListItemIcon>
                          <AlarmOnIcon className={classes.iconGetUpTimeView} />
                        </ListItemIcon>
                        {s.nap === '0' ? (
                          <ListItemIcon>
                            <Brightness3Icon
                              className={classes.iconGetUpTimeView2nd}
                            />
                          </ListItemIcon>
                        ) : (
                          <ListItemIcon>
                            <BatteryCharging30Icon
                              className={classes.iconGetUpTimeView2nd}
                            />
                          </ListItemIcon>
                        )}
                        <ListItemText
                          className={classes.weightText}
                          primary={
                            s.timeStart === ''
                              ? moment(new Date(s.timeComplete)).format('HH:mm')
                              : moment(new Date(s.timeStart)).format('HH:mm') +
                                '~' +
                                moment(new Date(s.timeComplete)).format('HH:mm')
                          }
                          classes={{
                            primary: classes.textGetUpTimeView,
                            secondary: classes.textGetUpDate
                          }}
                          secondary={
                            s.dateStart !== '' && s.dateStart !== s.date
                              ? moment(new Date(s.dateStart)).format('M/D') +
                                ' - ' +
                                moment(new Date(s.date)).format('M/D')
                              : 'On ' + moment(new Date(s.date)).format('l')
                          }
                        />
                        <IconButton
                          onClick={() => this.handleSessionEdit(s.id)}
                          className={classes.iconBtnCheck}
                          size="small"
                        >
                          <EditIcon
                            style={{
                              color: 'lightgrey',
                              fontSize: 20
                            }}
                          />
                        </IconButton>
                        <IconButton
                          onClick={() => this.handleSessionDelete(s.id)}
                          className={classes.iconBtnCheck}
                          size="small"
                        >
                          <DeleteIcon
                            style={{
                              color: 'lightgrey',
                              fontSize: 20
                            }}
                          />
                        </IconButton>
                      </ListItem>

                      {(s.hrsDuration || s.sleepScore || s.brainClearness) && (
                        <ListItem
                          key={`sessiodetail-${s.id}`}
                          className={classes.listItemSessionView}
                        >
                          {s.hrsDuration &&
                            s.hrsDuration !== '' && (
                              <Paper className={classes.paperWidget}>
                                <Typography
                                  style={{ color: 'dimgrey', fontSize: 18 }}
                                >
                                  {s.hrsDuration}
                                </Typography>
                                <Typography
                                  style={{ color: 'lightgrey', fontSize: 12 }}
                                >
                                  Hours
                                </Typography>
                              </Paper>
                            )}
                          {s.sleepScore !== '' && (
                            <Paper className={classes.paperWidget}>
                              <Typography
                                style={{ color: 'dimgrey', fontSize: 18 }}
                              >
                                {s.sleepScore}%
                              </Typography>
                              <Typography
                                style={{ color: 'lightgrey', fontSize: 12 }}
                              >
                                Sleep Quality
                              </Typography>
                            </Paper>
                          )}
                          {s.brainClearness !== '' && (
                            <Paper className={classes.paperWidget}>
                              <Typography
                                style={{ color: 'dimgrey', fontSize: 18 }}
                              >
                                {s.brainClearness === '10'
                                  ? 'Very clear'
                                  : s.brainClearness === '20'
                                    ? 'Clear'
                                    : s.brainClearness === '30'
                                      ? 'Normal'
                                      : s.brainClearness === '40'
                                        ? 'Unclear'
                                        : 'Very unclear'}
                              </Typography>
                              <Typography
                                style={{ color: 'lightgrey', fontSize: 12 }}
                              >
                                Brain Clearness
                              </Typography>
                            </Paper>
                          )}
                        </ListItem>
                      )}

                      {(s.mood || s.comment) && (
                        <ListItem
                          key={`sessioninfo-${s.id}`}
                          className={classes.listItemSessionView}
                        >
                          {s.mood !== 0 && (
                            <div className={classes.divWidgetMood}>
                              <Paper className={classes.paperWidgetMood}>
                                <Typography
                                  style={{ color: 'dimgrey', fontSize: 18 }}
                                >
                                  {s.mood === '10'
                                    ? ':)'
                                    : s.mood === '20'
                                      ? ':|'
                                      : this.props.resultUserSleep
                                          .sessionsDataByDate[0].mood === '30'
                                        ? ':('
                                        : ''}
                                </Typography>
                              </Paper>
                            </div>
                          )}

                          {s.comment !== '' && (
                            <Paper className={classes.paperWidgetComment}>
                              <Typography
                                style={{ color: 'lightgrey', fontSize: 12 }}
                              >
                                Comment
                              </Typography>
                              <Typography
                                style={{ color: 'dimgrey', fontSize: 18 }}
                              >
                                {s.comment}
                              </Typography>
                            </Paper>
                          )}
                        </ListItem>
                      )}
                    </List>
                  ))
                )}
              </List>
              <div className={classes.divAddModalButton}>
                <IconButton
                  className={classes.iconBtnCheckAdd}
                  onClick={() =>
                    this.handleOpenAdd(
                      this.props.resultUserSleep.sessionsDataByDate[0]
                        ? this.props.resultUserSleep.sessionsDataByDate[0].date
                        : moment().format('l')
                    )
                  }
                >
                  <AddIcon className={classes.iconClear} />
                </IconButton>
              </div>
            </div>
          </Paper>
        </Modal>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.OpenAdd}
          onClose={this.handleCloseAdd}
          className={classes.modalAddToday}
          disableBackdropClick
          disableAutoFocus
        >
          {this.state.isCompletedAdd ? (
            <Paper className={classes.paperAddTodayMoreInfo}>
              <div id="clearBtnBedTime" className={classes.divAddTpday}>
                <div className={classes.divClearButton}>
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleCloseAdd}
                  >
                    <ClearIcon className={classes.iconClear} />
                  </IconButton>
                </div>
                <List>
                  <ListItem className={classes.listItemSleepTimeComplete}>
                    <ListItemIcon>
                      <AccessTimeIcon className={classes.iconGetUpTime} />
                    </ListItemIcon>
                    <ListItemText
                      className={classes.weightText}
                      primary={moment(
                        new Date(
                          this.props.resultUserSleep.sessionData.timeComplete
                        )
                      ).format('HH:mm')}
                      classes={{
                        primary: classes.textGetUpTime,
                        secondary: classes.textGetUpDate
                      }}
                      secondary={
                        'Get Up on ' +
                        moment(
                          new Date(this.props.resultUserSleep.sessionData.date)
                        ).format('l')
                      }
                    />
                    <IconButton
                      onClick={() =>
                        this.handleSessionEdit(
                          this.props.resultUserSleep.sessionData.id
                        )
                      }
                      className={classes.iconBtnCheck}
                      size="small"
                    >
                      <EditIcon style={{ color: 'grey', fontSize: 20 }} />
                    </IconButton>
                  </ListItem>
                  <ListItem className={classes.listItemBedtimeDate}>
                    <ListItemIcon>
                      <Brightness3Icon
                        className={classes.iconSleepAtTimeDate}
                      />
                    </ListItemIcon>
                    <ListItemIcon>
                      <AlarmOnIcon className={classes.iconSleepAtTimeDate} />
                    </ListItemIcon>
                    <TextField
                      id="SleepAtTime"
                      label="Sleep Time"
                      type="time"
                      defaultValue={
                        this.props.resultUserSleep.sessionData.timeStart === ''
                          ? '22:30'
                          : moment(
                              new Date(
                                this.props.resultUserSleep.sessionData.timeStart
                              )
                            ).format('HH:mm')
                      }
                      onChange={this.handleChangeAddMoreInfo('timeStart')}
                      className={classes.textFieldSmall}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                    />
                    <TextField
                      id="SleepAtDay"
                      label="Date"
                      type="date"
                      defaultValue={
                        this.props.resultUserSleep.sessionData.dateStart === ''
                          ? moment(
                              new Date(
                                this.props.resultUserSleep.sessionData.date
                              )
                            )
                              .subtract(1, 'day')
                              .format('YYYY-MM-DD')
                          : moment(
                              new Date(
                                this.props.resultUserSleep.sessionData.dateStart
                              )
                            ).format('YYYY-MM-DD')
                      }
                      onChange={this.handleChangeAddMoreInfo('dateStart')}
                      className={classes.textFieldSmall}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <IconButton
                      onClick={this.saveSleepTimeDate}
                      disabled={!this.state.isSleepTimeDateAdded}
                      className={classes.iconBtnCheck}
                      size="small"
                    >
                      <CheckIcon
                        style={{
                          color: this.state.isSleepTimeDateAdded
                            ? 'blue'
                            : 'lightgrey',
                          fontSize: 20
                        }}
                      />
                    </IconButton>
                  </ListItem>
                  <ListItem className={classes.listItemSleepTimeComplete}>
                    <ListItemIcon>
                      <ShowChartIcon className={classes.iconSleepScore} />
                    </ListItemIcon>
                    <TextField
                      id="SleepScore"
                      label="Sleep Quality (%)"
                      value={this.props.resultUserSleep.sessionData.sleepScore}
                      onChange={this.handleChangeAddMoreInfo('sleepScore')}
                      className={classes.textFieldMediumLength}
                    />
                    <Paper className={classes.paperNap}>
                      {this.state.isNap ? (
                        <CheckBoxIcon
                          onClick={this.handleClickNap}
                          style={{
                            color: 'lightblue',
                            fontSize: 22,
                            cursor: 'pointer'
                          }}
                        />
                      ) : (
                        <CheckBoxOutlineBlankIcon
                          onClick={this.handleClickNap}
                          style={{
                            color: 'lightgrey',
                            fontSize: 22,
                            cursor: 'pointer'
                          }}
                        />
                      )}
                      {'  '}
                      <span
                        style={{ color: 'grey', fontSize: 14, paddingLeft: 5 }}
                      >
                        {' '}
                        Nap
                      </span>
                    </Paper>
                  </ListItem>
                  <ListItem className={classes.listItemBedtimeDate}>
                    <ListItemIcon>
                      <SentimentSatisfiedIcon
                        className={classes.iconSleepAtTimeDate}
                      />
                    </ListItemIcon>
                    <FormControl className={classes.textFieldShortLength}>
                      <InputLabel htmlFor="mood">Mood</InputLabel>
                      <Select
                        native
                        value={this.props.resultUserSleep.sessionData.mood}
                        onChange={this.handleChangeAddMoreInfo('mood')}
                        inputProps={{
                          name: 'mood',
                          id: 'mood'
                        }}
                      >
                        <option value="" />
                        <option value={10}>:)</option>
                        <option value={20}>:|</option>
                        <option value={30}>:(</option>
                      </Select>
                    </FormControl>
                    <ListItemIcon>
                      <FilterDramaIcon
                        className={classes.iconSleepAtTimeDate}
                      />
                    </ListItemIcon>
                    <FormControl className={classes.textFieldMediumLength}>
                      <InputLabel htmlFor="clearness">
                        Brain Clearness
                      </InputLabel>
                      <Select
                        native
                        value={
                          this.props.resultUserSleep.sessionData.brainClearness
                        }
                        onChange={this.handleChangeAddMoreInfo(
                          'brainClearness'
                        )}
                        inputProps={{
                          name: 'brainClearness',
                          id: 'brainClearness'
                        }}
                      >
                        <option value="" />
                        <option value={10}>Very Clear</option>
                        <option value={20}>Clear</option>
                        <option value={30}>Normal</option>
                        <option value={40}>Unclear</option>
                        <option value={50}>Very Unclear</option>
                      </Select>
                    </FormControl>
                  </ListItem>
                  <ListItem className={classes.listItemSleepTimeComplete}>
                    <ListItemIcon>
                      <CommentIcon className={classes.iconSleepScore} />
                    </ListItemIcon>
                    <TextField
                      id="commentAdd"
                      label="Comment"
                      multiline
                      value={this.state.comment}
                      onChange={this.handleChangeAddMoreInfo('comment')}
                      margin="normal"
                      variant="outlined"
                    />
                    <IconButton
                      onClick={this.saveComment}
                      disabled={!this.state.isCommented}
                      className={classes.iconBtnCheck}
                      size="small"
                    >
                      <CheckIcon
                        style={{
                          color: this.state.isCommented ? 'blue' : 'lightgrey',
                          fontSize: 20
                        }}
                      />
                    </IconButton>
                  </ListItem>
                  <ListItem className={classes.modalContentDone}>
                    <ListItemText />
                    <Button
                      onClick={this.handleCloseAdd}
                      className={classes.iconBtnCheck}
                      size="small"
                    >
                      {' '}
                      <span style={{ color: 'grey', fontSize: 15 }}>Done</span>
                      <ChevronRightIcon
                        style={{ color: 'grey', fontSize: 20, paddingLeft: 10 }}
                      />
                    </Button>
                  </ListItem>
                </List>
              </div>
            </Paper>
          ) : (
            <Paper className={classes.paperAddToday}>
              <div id="GetUpTime" className={classes.divAddTpday}>
                <div className={classes.divClearButton}>
                  <IconButton
                    className="btn btn-default btn-style"
                    onClick={this.handleCloseAdd}
                  >
                    <ClearIcon className={classes.iconClear} />
                  </IconButton>
                </div>
                <List>
                  <ListItem className={classes.listItemGetUpTime}>
                    <ListItemIcon>
                      <AccessTimeIcon className={classes.iconGetUpTime} />
                    </ListItemIcon>
                    <TextField
                      id="GetUpTimeToday"
                      label="Get Up Time"
                      type="time"
                      defaultValue={moment(
                        new Date(this.state.timeComplete)
                      ).format('HH:mm')}
                      onChange={this.handleChangeAdd('timeComplete')}
                      className={classes.textFieldGetUpTime}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                    />
                  </ListItem>
                  <ListItem className={classes.listItemGetUpDate}>
                    <ListItemIcon>
                      <DateRangeIcon className={classes.iconSleepAtTimeDate} />
                    </ListItemIcon>
                    <TextField
                      id="GetUpDate"
                      label="Date"
                      type="date"
                      defaultValue={moment(new Date(this.state.date)).format(
                        'YYYY-MM-DD'
                      )}
                      onChange={this.handleChangeAdd('date')}
                      className={classes.textFieldGetUpDate}
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </ListItem>
                </List>
              </div>
              <div id="buttons" className={classes.btnAddModal}>
                <Button
                  onClick={this.handleCompleteAdd}
                  className={classes.iconBtnCheck}
                  size="small"
                >
                  <CheckIcon />
                </Button>
                <Button className={classes.iconBtnCheck} size="small">
                  <ReplayIcon />
                </Button>
              </div>
            </Paper>
          )}
        </Modal>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/sleep.js